import { CircularProgress, Collapse, Stack, Typography } from "@mui/material";
import { memo } from "react";

export const LoadingMessage = memo(function Loading({
  loading,
}: {
  loading: boolean;
}): React.JSX.Element {
  const messages = [
    "Calculating...",
    "Hmmm, let me see...",
    "Generating a suggestion...",
    "Thinking...",
    "Composing...",
    "Writing...",
    "Generating...",
    "Tough one! Give me a moment...",
    "Ooh, this is a tricky one...",
    "Let me think about that...",
    "Let me think...",
    "Working on it...",
    "Working...",
    "I'm on it...",
    "I'm on it!",
  ];

  const message = messages[Math.floor(Math.random() * messages.length)];
  return (
    <Collapse in={loading}>
      <Stack
        direction="column"
        alignItems="center"
        alignContent="center"
        color="text.discreet"
        m={2}
      >
        <Typography variant="body1" color="text.discreet">
          {message}
        </Typography>

        <CircularProgress color="inherit" sx={{ m: 1 }} />
      </Stack>
    </Collapse>
  );
});
